import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationForecastRateApiService } from './organization-forecast-rate-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationForecastRateApiService extends GeneratedOrganizationForecastRateApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
